






import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {}
})
export default class ConnectWithSocialNetwork extends Vue {
  @Prop(String) name!: String;
  @Prop(Boolean) removeClick!: boolean;

  get imageUrl() {
    return require("@/assets/icons/" + this.name.toLowerCase() + "-white.svg");
  }

  setStep() {
    // this.$router.push({ name: "Crear cuenta", params: { activeStep: "2" } });
    if (!this.removeClick)
      (this as any).$root[`${this.name.toLowerCase()}Login`]();
  }
}
